import { z } from "zod";
import { AwUserIdSchema } from "../traits/aw/awUserId.trait";

export enum DictionaryUserSchemaEnum {
	DictionaryUser = "DictionaryUser"
};

export const DictionaryUserSchema = AwUserIdSchema
	.merge(z.object({
		"@id": z.string(), // "/api/dictionary_users/1"
		"@type": z.string(), // "DictionaryUser"
		id: z.number(), // 1
		libelle_audio: z.string(), // "DURIF MARINE"
		aw_user_id: z.string(), // "1"
	}))
	.describe(DictionaryUserSchemaEnum.DictionaryUser);

export type DictionaryUser = z.infer<typeof DictionaryUserSchema>;
